import React, { useState, useEffect } from "react";
import { useForm,} from "react-hook-form";
import { useNavigate, useLocation } from "react-router-dom";

import { yupResolver } from "@hookform/resolvers/yup";
import { taskmanagementschema } from "../../../../../JsonData/CreateTaskConfig";

import { toast, } from "react-toastify";

import FormHandler from "../../../Common/Form/FormHandler/FormHandler";



import { ExecuteSopsConfig } from "../../ExecuteSopsForm/ExecuteSopsConfig";

import "./SopsInstanceForm.css";

import { useTranslation } from "react-i18next";
import { FaChevronUp, FaChevronDown, FaPencilAlt, FaClipboardList, FaBan } from "react-icons/fa";

import {
  getData,
  postDataWithBody,
  putDataWithBody,
  
} from "../../../../../Services/Services";

import {
  getTaskConfigsURL,
  getAllActiveRole,
  findTaskById,
  getTaskListURL,

  getSopInstanceResourceById,
  getSopMasterData,
  getThemeURL,
  getMatrixResources,
  changeSeverityAndUpdateResources,
  getActiveMasterSOPById,
  updateSopInstanceResources,
  getSopInstanceSummaryBySopInstance,
} from "../../../../../Services/EndPoints";

import Loader from "react-spinner-loader";

import TaskModalWithCommentSopCancel from "../../../../../Components/UiComponents/TaskModalWithComment/TaskModalWithCommentSopCancel";
import ConfirmpopupSop from "../../../Common/ConfirmPopup/ConfirmpopupSop";
//Task Management

const getTaskProgressPercent = (taskSummary) => taskSummary?.progressPercent ?? 0;

const formatIncidentDateTime = (val) => {
  if (!val) return "N/A";
  const d = new Date(val);
  if (isNaN(d.getTime())) return String(val);
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yy = d.getFullYear();
  let h = d.getHours();
  const min = String(d.getMinutes()).padStart(2, "0");
  const ampm = h >= 12 ? "PM" : "AM";
  h = h % 12 || 12;
  return `${dd}-${mm}-${yy}, ${String(h).padStart(2, "0")}:${min} ${ampm}`;
};

// Humanizes a raw elapsed-minutes value into the largest sensible unit —
// e.g. 1.5 -> "2 min", 90 -> "2 hr", 1500 -> "1 day", 44000 -> "1 month".
const formatElapsedDuration = (minutesValue) => {
  if (minutesValue === undefined || minutesValue === null || isNaN(Number(minutesValue))) return "N/A";
  const pluralize = (n, unit) => `${n} ${unit}${n === 1 ? "" : "s"}`;
  const totalMinutes = Number(minutesValue);
  const totalSeconds = totalMinutes * 60;

  // Round each candidate BEFORE checking the unit boundary — otherwise a raw
  // value like 59.6 min passes the "< 60 min" check but then displays as the
  // rounded "60 mins" instead of correctly bumping up to "1 hr".
  const roundedSeconds = Math.round(totalSeconds);
  if (roundedSeconds < 60) return pluralize(roundedSeconds, "sec");

  const roundedMinutes = Math.round(totalMinutes);
  if (roundedMinutes < 60) return pluralize(roundedMinutes, "min");

  const totalHours = totalMinutes / 60;
  const roundedHours = Math.round(totalHours);
  if (roundedHours < 24) return pluralize(roundedHours, "hr");

  const totalDays = totalHours / 24;
  const roundedDays = Math.round(totalDays);
  if (roundedDays < 30) return pluralize(roundedDays, "day");

  if (roundedDays < 365) {
    const totalMonths = totalDays / 30;
    return pluralize(Math.round(totalMonths), "month");
  }

  const totalYears = totalDays / 365;
  return pluralize(Math.round(totalYears), "year");
};

const SopsInstanceForm = (props) => {
  const [CreateTaskConfig, setCreateTaskConfig] = useState(() =>
    ExecuteSopsConfig.map(tab => ({ ...tab, fields: tab.fields.map(f => ({ ...f, options: [] })) }))
  );
  const [loader, setLoader] = useState(false);
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(0);
  const { t } = useTranslation();
  const [taskConfigs, setTaskConfigs] = useState([]);
  const [setViewTask, setViewTaskById] = useState(null);
  const [roleArr, setRoleArr] = useState([]);
  const [showPop, setShowPop] = React.useState(false);
  const [showConfirmPopup, setshowConfirmPopup] = React.useState(false);
  const [resourcesData, setResourcesData] = useState(""); // New state for resources
  const [fullResourcesData, setFullResourcesData] = useState([]);
  const [incidentId, setIncidentId] = useState(null);
  
  const { state } = useLocation();
  // Get data from state or session storage
  const [formData, setFormData] = useState(null);
  const [id, setId] = useState(null);
  const [selectedManualResources, setSelectedManualResources] = useState([]);
  const [resourceSearchTerm, setResourceSearchTerm] = useState("");
  const [isResourcesExpanded, setIsResourcesExpanded] = useState(false);
  const [showNoResourcesModal, setShowNoResourcesModal] = useState(false);
  const [editResources, setEditResources] = useState([]);
  const [checkedEditResources, setCheckedEditResources] = useState({});
  const [isLoadingEditResources, setIsLoadingEditResources] = useState(false);
  const [isUpdatingResources, setIsUpdatingResources] = useState(false);
  const [selectedSeverity, setSelectedSeverity] = useState("");
  const [stateId, setStateId] = useState(null);
  const [userEmail, setUserEmail] = useState("");
  const [sopMasterId, setSopMasterId] = useState(null);
  const [sopInstanceId, setSopInstanceId] = useState(null);
  const [regionId, setRegionId] = useState(null);
  const [cancelReason, setCancelReason] = useState(null);
  const [cancelRemarks, setCancelRemarks] = useState(null);
  const [severityHistory, setSeverityHistory] = useState([]);
  const [showSeverityPopup, setShowSeverityPopup] = useState(false);
  const [severityResources, setSeverityResources] = useState([]);
  const [severityChangeReason, setSeverityChangeReason] = useState("");
  const [pendingSeverity, setPendingSeverity] = useState("");
  const [isSeverityLoading, setIsSeverityLoading] = useState(false);
  const [incidentSeqId, setIncidentSeqId] = useState(null);
  const [taskSummary, setTaskSummary] = useState(null);
  const [slaInfo, setSlaInfo] = useState({
    sla_hours: null,
    target_datetime: null,
    sla_elapsed_minutes: null,
    sla_breached: null,
  });
  // Only present once the instance is actually cancelled/completed — render
  // conditionally wherever these are shown, never as a bare "N/A" field.
  const [lifecycleInfo, setLifecycleInfo] = useState({
    cancelled_on: null,
    completed_on: null,
  });

  console.log("tas",setActiveTab)
  console.log("tas1",setViewTask)
  console.log("tas2",resourcesData)
   console.log("tas3",resourcesData)

  // Session storage key
  const SESSION_STORAGE_KEY = "sops_instance_form_data";

  useEffect(() => {
    // Retrieve data - first check state, then session storage
    let stateData = state?.data;
    
    // If state data exists, save it to session storage
    if (stateData) {
      sessionStorage.setItem(SESSION_STORAGE_KEY, JSON.stringify(stateData));
      setFormData(stateData);
      setId(stateData.id);
      setSelectedSeverity(stateData.incident_severity || "");
      setSlaInfo({
        sla_hours: stateData.sla_hours,
        target_datetime: stateData.target_datetime,
        sla_elapsed_minutes: stateData.sla_elapsed_minutes,
        sla_breached: stateData.sla_breached,
      });
      setLifecycleInfo({
        cancelled_on: stateData.cancelled_on,
        completed_on: stateData.completed_on,
      });
    }
    // If no state data, try to get from session storage
    else {
      const storedData = sessionStorage.getItem(SESSION_STORAGE_KEY);
      if (storedData) {
        const parsedData = JSON.parse(storedData);
        setFormData(parsedData);
        setId(parsedData.id);
        setSelectedSeverity(parsedData.incident_severity || "");
        setSlaInfo({
          sla_hours: parsedData.sla_hours,
          target_datetime: parsedData.target_datetime,
          sla_elapsed_minutes: parsedData.sla_elapsed_minutes,
          sla_breached: parsedData.sla_breached,
        });
        setLifecycleInfo({
          cancelled_on: parsedData.cancelled_on,
          completed_on: parsedData.completed_on,
        });
      } else {
        // No data in state or session storage, redirect to list view
        toast.error("No SOP instance data found. Redirecting to view page.", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2000,
        });
        setTimeout(() => navigate("../viewsops-instance"), 2000);
      }
    }
  }, [state, navigate]);

  useEffect(() => {
    const fetchStateId = async () => {
      const userProfile = await getData(getThemeURL);
      setStateId(userProfile[0]?.state_id || null);
      setUserEmail(userProfile[0]?.email || "");
    };
    fetchStateId();
  }, []);

  const handleSeverityChange = async (newSeverity) => {
    if (!newSeverity) {
      setSelectedSeverity("");
      return;
    }
    const hazardType = formData?.hazard_type;
    if (!hazardType || !stateId) {
      setSelectedSeverity(newSeverity);
      return;
    }
    setIsSeverityLoading(true);
    try {
      const url = `${getMatrixResources}?hazardType=${encodeURIComponent(hazardType)}&severityLevel=${encodeURIComponent(newSeverity)}&stateId=${stateId}`;
      const res = await getData(url);
      setSeverityResources(res || []);
      setPendingSeverity(newSeverity);
      setSeverityChangeReason("");
      setShowSeverityPopup(true);
    } catch (err) {
      console.error("Failed to fetch matrix resources:", err);
      setSeverityResources([]);
      setPendingSeverity(newSeverity);
      setSeverityChangeReason("");
      setShowSeverityPopup(true);
    } finally {
      setIsSeverityLoading(false);
    }
  };

  const handleSeverityPopupCancel = () => {
    setShowSeverityPopup(false);
    setPendingSeverity("");
    setSeverityResources([]);
    setSeverityChangeReason("");
  };

  const handleSeverityPopupSubmit = async () => {
    try {
      setIsSeverityLoading(true);
      const payload = {
        sopInstanceId: sopInstanceId,
        hazardType: formData?.hazard_type,
        severityLevel: pendingSeverity,
        oldSeverityLevel: selectedSeverity,
        stateId: stateId,
        incidentId: incidentId,
        sopMasterId: sopMasterId,
        userEmail: userEmail,
        remarks: severityChangeReason,
      };
      await postDataWithBody(changeSeverityAndUpdateResources, payload, {});
      setShowSeverityPopup(false);
      setPendingSeverity("");
      setSeverityResources([]);
      setSeverityChangeReason("");
      toast.success("Severity updated successfully.", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
      navigate("../Sop-instance-list");
    } catch (error) {
      console.error("Error changing severity:", error);
      toast.error("Failed to update severity. Please try again.", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 3000,
      });
    } finally {
      setIsSeverityLoading(false);
    }
  };

  // New function to fetch master user task list and extract incident_id, sop_id, id
  const fetchMasterUserTaskList = async (sopId) => {
    try {
      const masterUserTaskListResponse = await getData(getSopMasterData + sopId);
      const masterUserTaskList = masterUserTaskListResponse || [];

      if (masterUserTaskList.length > 0) {
        setIncidentId(masterUserTaskList[0].incident_id || null);
        setSopInstanceId(masterUserTaskList[0].id || null);
        setSopMasterId(masterUserTaskList[0].sop_id || null);
        setSeverityHistory(masterUserTaskList[0].severityHistory || []);
        setRegionId(masterUserTaskList[0].regionId || null);
        setCancelReason(masterUserTaskList[0].cancelReason || null);
        setCancelRemarks(masterUserTaskList[0].cancelRemarks || null);
        setSlaInfo((prev) => ({
          sla_hours: masterUserTaskList[0].sla_hours ?? prev.sla_hours,
          target_datetime: masterUserTaskList[0].target_datetime ?? prev.target_datetime,
          sla_elapsed_minutes: masterUserTaskList[0].sla_elapsed_minutes ?? prev.sla_elapsed_minutes,
          sla_breached: masterUserTaskList[0].sla_breached ?? prev.sla_breached,
        }));
        setLifecycleInfo((prev) => ({
          cancelled_on: masterUserTaskList[0].cancelled_on ?? prev.cancelled_on,
          completed_on: masterUserTaskList[0].completed_on ?? prev.completed_on,
        }));

        const seqId = masterUserTaskList[0].incidentSeqId || null;
        setIncidentSeqId(seqId);
        if (seqId) {
          try {
            const summary = await getData(
              getSopInstanceSummaryBySopInstance.replace("SOPINSTANCEID", sopId).replace("INCIDENTID", seqId)
            );
            setTaskSummary(summary?.taskSummary || null);
          } catch (summaryError) {
            console.error("Error fetching SOP instance summary:", summaryError);
            setTaskSummary(null);
          }
        } else {
          setTaskSummary(null);
        }
      } else {
        setIncidentId(null);
        setSopInstanceId(null);
        setSopMasterId(null);
        setSeverityHistory([]);
        setRegionId(null);
        setCancelReason(null);
        setCancelRemarks(null);
        setIncidentSeqId(null);
        setTaskSummary(null);
      }
    } catch (error) {
      console.error("Error fetching master user task list:", error);
      setIncidentId(null);
      setSopInstanceId(null);
      setSopMasterId(null);
      setSeverityHistory([]);
      setRegionId(null);
      setCancelReason(null);
      setCancelRemarks(null);
      setIncidentSeqId(null);
      setTaskSummary(null);
    }
  };

  // New function to fetch resources
  const fetchResources = async (sopId) => {
    try {
      const getResourcesToDeploy = await getData(`${getSopInstanceResourceById}${sopId}`);
      if (getResourcesToDeploy && getResourcesToDeploy.length > 0) {
        setFullResourcesData(getResourcesToDeploy);
        const resourceNames = getResourcesToDeploy.map(resource => `${resource.name} (${resource.agency_name})`).join(', ');
        setResourcesData(resourceNames);
      } else {
        setFullResourcesData([]);
        setResourcesData("NA");
      }
    } catch (error) {
      console.error("Error fetching resources:", error);
      setFullResourcesData([]);
      setResourcesData("NA");
    }
  };

  // Fetch the master SOP's default resources so they can be reviewed/added when no resources are assigned yet
  const handleOpenResourceEditModal = async () => {
    setIsLoadingEditResources(true);
    setShowNoResourcesModal(true);
    try {
      const regionParam = regionId ? `&regionId=${regionId}` : "";
      const res = await getData(`${getActiveMasterSOPById}/${stateId}?sopId=${sopMasterId}${regionParam}`);
      const sopData = Array.isArray(res) ? res?.[0] : null;
      const resources = sopData?.resources?.filter(r => r.resource_name) || [];
      setEditResources(resources);
      const defaultChecked = {};
      resources.forEach((r, i) => { defaultChecked[r.resourceId ?? i] = true; });
      setCheckedEditResources(defaultChecked);
    } catch (error) {
      console.error("Error fetching master SOP resources:", error);
      setEditResources([]);
      setCheckedEditResources({});
    } finally {
      setIsLoadingEditResources(false);
    }
  };

  const handleEditResourceCheckbox = (resourceKey) => {
    setCheckedEditResources(prev => ({ ...prev, [resourceKey]: !prev[resourceKey] }));
  };

  const handleSelectAllEditResources = (checked) => {
    const all = {};
    editResources.forEach((r, i) => { all[r.resourceId ?? i] = checked; });
    setCheckedEditResources(all);
  };

  const handleUpdateResources = async () => {
    setIsUpdatingResources(true);
    try {
      const resourceWrapperList = editResources
        .filter((r, i) => checkedEditResources[r.resourceId ?? i])
        .map((r) => ({
          resourceId: r.resourceId,
          resourceName: r.resource_name,
          facilityId: r.facility_id,
        }));
      const payload = {
        sopInstanceId: sopInstanceId,
        sopId: sopMasterId,
        userId: userEmail,
        resourceWrapperList,
      };
      const res = await putDataWithBody(updateSopInstanceResources, payload, {});
      if (res?.status === "success") {
        toast.success(res.msg || "Resources updated successfully.", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2000,
        });
        setShowNoResourcesModal(false);
        fetchResources(id);
      } else {
        toast.error(res?.msg || "Failed to update resources.", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 3000,
        });
      }
    } catch (error) {
      console.error("Error updating resources:", error);
      toast.error("Failed to update resources. Please try again.", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 3000,
      });
    } finally {
      setIsUpdatingResources(false);
    }
  };

  useEffect(() => {
    if (id) {
      fetchResources(id);
      fetchMasterUserTaskList(id);
    }
  }, [id]);

  // Manual resource selection is only allowed while the SOP instance is still active
  const canSelectResources = formData?.status === "Started" || formData?.status === "In-Progress";
  // Severity can only be changed while the instance is still in its initial ("Started") state.
  const isSeverityLocked = ["In-Progress", "Completed", "Closed"].includes(formData?.status);

  // Derived: separate automatic and manual resources
  const automaticResources = fullResourcesData.filter(r => r.is_automatic === true);
  const manualResources = fullResourcesData.filter(r => r.is_manual === true);

  // Filtered manual resources based on search
  const filteredManualResources = manualResources.filter(r =>
    r.name.toLowerCase().includes(resourceSearchTerm.toLowerCase()) ||
    r.agency_name.toLowerCase().includes(resourceSearchTerm.toLowerCase())
  );

  // Checkbox handlers
  const handleResourceCheckbox = (resourceId) => {
    setSelectedManualResources(prev =>
      prev.includes(resourceId)
        ? prev.filter(id => id !== resourceId)
        : [...prev, resourceId]
    );
  };

  const handleSelectAllResources = () => {
    const allFilteredIds = filteredManualResources.map(r => r.id);
    setSelectedManualResources(prev => {
      const newSet = new Set(prev);
      allFilteredIds.forEach(id => newSet.add(id));
      return Array.from(newSet);
    });
  };

  const handleDeselectAllResources = () => {
    const filteredIds = filteredManualResources.map(r => r.id);
    setSelectedManualResources(prev => prev.filter(id => !filteredIds.includes(id)));
  };

  const areAllFilteredSelected = filteredManualResources.length > 0 &&
    filteredManualResources.every(r => selectedManualResources.includes(r.id));

  console.log(formData, "newdata");
  console.log(id, "SOP INSTANCE ID")

  console.log(formData, "checking the data");

  const {
    register,
    getValues,
    reset,
    control,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(taskmanagementschema[activeTab]),
    mode: "all",
  });

  useEffect(() => {
    if (formData) {
      getInitData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData]);

  // GET
  async function getViewData() {
    const userProfile = await getData(getThemeURL);
          const state_id = userProfile[0]?.state_id;
    await getData(getTaskListURL.replace("STATEID",state_id));
    // setViewTask(getViewData);
    if (id) {
      await populateViewFormFrEdit(id);
    }
  }

  //EDIT
  async function populateViewFormFrEdit(id) {
    var viewData = await postDataWithBody(findTaskById, [id], {});
    viewData = viewData[0];
    setViewTaskById(viewData);
    reset(viewData);
  }

  const GenerateForm = (fields, register, errors, control) => {
    return (
      <div>
        {taskConfigs.length > 0 && roleArr.length > 1 && (
          <FormHandler
            register={register}
            errors={errors}
            fields={fields}
            control={control}
            editId={id}
            columns={2}
            getValues={getValues}
            fileObjs={fileObjs}
            setFileObjs={setFileObjs}
          />
        )}
      </div>
    );
  };

  const generateTabsData = (tabWiseData) => {
    tabWiseData?.forEach((element) => {
      return (element.component = GenerateForm(
        element?.fields,
        register,
        errors,
        control
      ));
    });
    return tabWiseData;
  };

  async function getInitData() {
    setLoader(true);
    await getTaskConfigs();
    await fetchAllRoles();
    // await getTaskStatus();
    await getViewData();
    setLoader(false);
    if (id) {
      populateViewFormFrEdit(id);
    }
  }
  
  async function fetchAllRoles() {
    let rolearr = await getData(getAllActiveRole);
    setRoleArr(rolearr);
    let roleFrDropdown = [];
    for (let role in rolearr) {
      roleFrDropdown.push({
        label: rolearr[role].name,
        value: rolearr[role].id,
      });
    }
    CreateTaskConfig[0].fields[2]["options"] = roleFrDropdown;
    setCreateTaskConfig(CreateTaskConfig);
  }
  
  async function getTaskConfigs() {
    const userProfile = await getData(getThemeURL);
          const state_id = userProfile[0]?.state_id;
    let res = await postDataWithBody(
      `${getTaskConfigsURL}/${state_id}`,
      ["TSK_PRIOR", "INCDNT_CAT", "TSK_STAT", "TSK_TYP"],
      {}
    );
    setTaskConfigs(res);
    let config_type = {};
    for (let config in res) {
      if (config_type[res[config].category_name]) {
        config_type[res[config].category_name].push({
          label: res[config].value,
          value: res[config].id,
        });
      } else {
        config_type[res[config].category_name] = [
          { label: res[config].value, value: res[config].id },
        ];
      }
    }
    //alert(config_type["INCDNT_CAT"])
    CreateTaskConfig[0].fields[0]["options"] = config_type["INCDNT_CAT"];
    CreateTaskConfig[0].fields[2]["options"] = config_type["TSK_PRIOR"];
    CreateTaskConfig[0].fields[3]["options"] = config_type["TSK_STAT"];
    CreateTaskConfig[0].fields[3]["options"] = config_type["TSK_TYP"];
    setCreateTaskConfig(CreateTaskConfig);
  }

  const handleClickClose = () => {
    setshowConfirmPopup(true);
  };
  
  const handleclickCancel = async () => {
    setShowPop(true);
  };

  // Deploy Resources - only sends MANUAL resources (is_auto_execute === false)
 const handleDeployResources = () => {
  const selectedResources = manualResources
    .filter(resource => selectedManualResources.includes(resource.id))
    .map(resource => ({
      ...resource,
      incidentId: incidentId,
      sopInstanceId: sopInstanceId
    }));

  navigate("/resource-assign-list/deployment-resource", { 
    state: { 
      fullResourcesData: selectedResources,
    } 
  });
};


  // Initialize fileObjs state
  const [fileObjs, setFileObjs] = useState([]);

  generateTabsData(CreateTaskConfig);

  // Clear session storage on unmount or when navigating away
  useEffect(() => {
    return () => {
      // Uncomment below if you want to clear the storage when leaving the page
      // sessionStorage.removeItem(SESSION_STORAGE_KEY);
    };
  }, []);

  if (!formData) {
    return <Loader show={true} type="body" stack="vertical" message="Loading Data" />;
  }

  const createdByFullName =
    formData?.created_by_firstname && formData?.created_by_lastname
      ? `${formData.created_by_firstname} ${formData.created_by_lastname}`
      : formData?.created_by_firstname || "";
  const createdByDisplay = createdByFullName
    ? formData?.created_by_role_name
      ? `${createdByFullName} (${formData.created_by_role_name})`
      : createdByFullName
    : "N/A";

  return (
    <>
      <div className="mt-4">
        <Loader
          show={loader}
          type="body"
          stack="vertical"
          message="Loading Data"
        />

        <div className="form-body">
          <div className="registration__form--body">
            <div className="sop-instance-table">
              <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "16px 18px" }}>
                <div>
                  <div className="sop_instance_info">SOP Instance ID</div>
                  <div>{formData?.sopinstance_seq_id || "N/A"}</div>
                </div>
                <div>
                  <div className="sop_instance_info">Instance Name</div>
                  <div>{formData?.name || "N/A"}</div>
                </div>
                <div>
                  <div className="sop_instance_info">Status</div>
                  <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                    {(() => {
                      const statusMap = {
                        Started: { color: "#519EFE" },
                        "In-Progress": { color: "#fccd7c" },
                        Completed: { color: "#7cdb90" },
                        Cancel: { color: "#e95060" },
                        Closed: { color: "Gray" },
                      };
                      const s = statusMap[formData?.status];
                      return s ? (
                        <span style={{ width: "8px", height: "8px", backgroundColor: s.color, borderRadius: "50%", display: "inline-block", flexShrink: 0 }}></span>
                      ) : null;
                    })()}
                    {formData?.status || "N/A"}
                  </div>
                </div>
                <div>
                  <div className="sop_instance_info">Trigger Type</div>
                  <div>{formData?.is_auto_triggered ? "Auto" : "Manual"}</div>
                </div>

                <div>
                  <div className="sop_instance_info">Incident ID</div>
                  <div>{incidentSeqId || "N/A"}</div>
                </div>
                <div>
                  <div className="sop_instance_info">Incident Name</div>
                  <div>{formData?.incident || "N/A"}</div>
                </div>
                <div>
                  <div className="sop_instance_info">Severity</div>
                  <select
                    value={selectedSeverity}
                    onChange={e => handleSeverityChange(e.target.value)}
                    className="form-select form__select"
                    style={{ fontSize: "13px" }}
                    disabled={isSeverityLoading || isSeverityLocked}
                    title={isSeverityLocked ? `Severity can't be changed once the SOP instance is ${formData?.status}` : undefined}
                  >
                    <option value="">Select Severity</option>
                    <option value="Level 1 – Minor">Level 1 – Minor</option>
                    <option value="Level 2 – Moderate">Level 2 – Moderate</option>
                    <option value="Level 3 – Major">Level 3 – Major</option>
                    <option value="Level 4 – Critical">Level 4 – Critical</option>
                  </select>
                  {isSeverityLoading && (
                    <div style={{ fontSize: "11px", color: "#1C4E72", marginTop: "4px" }}>Loading resources…</div>
                  )}
                </div>
                <div>
                  <div className="sop_instance_info">Region</div>
                  <div>{formData?.region_names || "N/A"}</div>
                </div>

                <div>
                  <div className="sop_instance_info">Incident Date & Time</div>
                  <div>{formatIncidentDateTime(formData?.created_on)}</div>
                </div>
                <div>
                  <div className="sop_instance_info">SOP Name</div>
                  <div>{formData?.sop || "N/A"}</div>
                </div>
                <div>
                  <div className="sop_instance_info">Created By</div>
                  <div>{createdByDisplay}</div>
                </div>

                <div>
                  <div className="sop_instance_info">SLA Hours</div>
                  <div>{slaInfo.sla_hours ?? "N/A"}</div>
                </div>
                <div>
                  <div className="sop_instance_info">Target Time</div>
                  <div>{formatIncidentDateTime(slaInfo.target_datetime)}</div>
                </div>
                <div>
                  <div className="sop_instance_info">SLA Elapsed</div>
                  <div
                    title={
                      slaInfo.sla_elapsed_minutes !== undefined && slaInfo.sla_elapsed_minutes !== null
                        ? `${Number(slaInfo.sla_elapsed_minutes).toFixed(5)} min`
                        : undefined
                    }
                  >
                    {formatElapsedDuration(slaInfo.sla_elapsed_minutes)}
                  </div>
                </div>
                <div>
                  <div className="sop_instance_info">SLA Breached</div>
                  <div style={{ color: slaInfo.sla_breached ? "#B91C1C" : "#15803D", fontWeight: 600 }}>
                    {slaInfo.sla_breached ? "Yes" : "No"}
                  </div>
                </div>
                {lifecycleInfo.cancelled_on && (
                  <div>
                    <div className="sop_instance_info">Cancelled On</div>
                    <div>{formatIncidentDateTime(lifecycleInfo.cancelled_on)}</div>
                  </div>
                )}
                {lifecycleInfo.completed_on && (
                  <div>
                    <div className="sop_instance_info">Completed On</div>
                    <div>{formatIncidentDateTime(lifecycleInfo.completed_on)}</div>
                  </div>
                )}
              </div>
              <div className="row mt-3">
                <div className="col-sm-12">
                  <div className="sop_instance_info">SOP Description</div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <div>{formData?.description || "N/A"}</div>
                </div>
              </div>

              {taskSummary && (
                <div className="row mt-3">
                  <div className="col-sm-12">
                    <div style={{ fontWeight: 700, fontSize: "14px", color: "#1C4E72", marginBottom: "10px" }}>
                      Task Summary
                    </div>
                    <div style={{ display: "grid", gridTemplateColumns: "repeat(5, 1fr)", gap: "12px", marginBottom: "14px" }}>
                      {[
                        { label: "Total Tasks", value: taskSummary.totalTasks ?? 0, color: "#1C4E72", bg: "#EFF6FF" },
                        { label: "Completed", value: taskSummary.completedTasks ?? 0, color: "#15803D", bg: "#DCFCE7" },
                        { label: "In Progress", value: taskSummary.inProgressTasks ?? 0, color: "#92400E", bg: "#FEF3C7" },
                        { label: "Started", value: taskSummary.notStartedTasks ?? 0, color: "#64748B", bg: "#F1F5F9" },
                        { label: "Cancelled", value: taskSummary.cancelledTasks ?? 0, color: "#B91C1C", bg: "#FEE2E2" },
                      ].map((tile) => (
                        <div key={tile.label} style={{ background: tile.bg, borderRadius: "8px", padding: "10px 14px" }}>
                          <div style={{ fontSize: "18px", fontWeight: 800, color: tile.color }}>{tile.value}</div>
                          <div style={{ fontSize: "10px", fontWeight: 700, letterSpacing: ".4px", textTransform: "uppercase", color: "#98A2B3", marginTop: "2px" }}>{tile.label}</div>
                        </div>
                      ))}
                    </div>
                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                      <span style={{ fontSize: "10px", fontWeight: 700, letterSpacing: ".4px", textTransform: "uppercase", color: "#98A2B3" }}>Progress</span>
                      <div style={{ flex: 1, height: "8px", background: "#F1F5F9", borderRadius: "4px", overflow: "hidden" }}>
                        <div style={{ width: `${getTaskProgressPercent(taskSummary)}%`, height: "100%", background: "#2E6DA4" }}></div>
                      </div>
                      <span style={{ fontSize: "12px", fontWeight: 700, color: "#1C4E72" }}>{getTaskProgressPercent(taskSummary)}%</span>
                    </div>
                  </div>
                </div>
              )}

              {/* Cancellation Details */}
              {formData?.status === "Cancel" && (cancelReason || cancelRemarks) && (
                <div className="row mt-3">
                  <div className="col-sm-12">
                    <div style={{
                      background: "#fef2f2",
                      border: "1px solid #fca5a5",
                      borderRadius: "10px",
                      padding: "16px 20px",
                    }}>
                      <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "14px" }}>
                        <FaBan size={16} color="#dc2626" />
                        <span style={{ fontWeight: "700", fontSize: "14px", color: "#dc2626" }}>Cancellation Details</span>
                      </div>
                      <div className="row">
                        <div className="col-sm-4">
                          <div style={{ fontSize: "11px", fontWeight: "600", color: "#9ca3af", textTransform: "uppercase", letterSpacing: "0.04em", marginBottom: "4px" }}>
                            Cancel Reason
                          </div>
                          <div style={{ fontSize: "14px", fontWeight: "700", color: "#dc2626" }}>
                            {cancelReason || "N/A"}
                          </div>
                        </div>
                        <div className="col-sm-8">
                          <div style={{ fontSize: "11px", fontWeight: "600", color: "#9ca3af", textTransform: "uppercase", letterSpacing: "0.04em", marginBottom: "4px" }}>
                            Remarks
                          </div>
                          <div style={{ fontSize: "14px", color: "#374151" }}>
                            {cancelRemarks || "N/A"}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* Severity Change History */}
              {severityHistory.length > 0 && (
                <div className="row mt-4">
                  <div className="col-sm-12">
                    <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "12px" }}>
                      <span style={{ fontSize: "16px", color: "#1C4E72" }}>&#x21C4;</span>
                      <span style={{ fontWeight: "600", fontSize: "14px", color: "#1C4E72" }}>Severity Change History</span>
                    </div>
                    <div style={{ border: "1px solid #c8dff0", borderRadius: "8px", overflow: "hidden" }}>
                      <table style={{ width: "100%", borderCollapse: "collapse" }}>
                        <thead>
                          <tr>
                            <th style={{ backgroundColor: "#1C4E72", color: "#fff", padding: "10px 12px", fontSize: "12px", fontWeight: "600", border: "none", textAlign: "center", width: "60px" }}>S.NO</th>
                            <th style={{ backgroundColor: "#1C4E72", color: "#fff", padding: "10px 12px", fontSize: "12px", fontWeight: "600", border: "none", textAlign: "left" }}>Old Severity</th>
                            <th style={{ backgroundColor: "#1C4E72", color: "#fff", padding: "10px 12px", fontSize: "12px", fontWeight: "600", border: "none", textAlign: "left" }}>New Severity</th>
                            <th style={{ backgroundColor: "#1C4E72", color: "#fff", padding: "10px 12px", fontSize: "12px", fontWeight: "600", border: "none", textAlign: "left" }}>Changed By</th>
                            <th style={{ backgroundColor: "#1C4E72", color: "#fff", padding: "10px 12px", fontSize: "12px", fontWeight: "600", border: "none", textAlign: "left" }}>Remarks</th>
                            <th style={{ backgroundColor: "#1C4E72", color: "#fff", padding: "10px 12px", fontSize: "12px", fontWeight: "600", border: "none", textAlign: "left" }}>Changed On</th>
                          </tr>
                        </thead>
                        <tbody>
                          {severityHistory.map((item, idx) => (
                            <tr key={item.id} style={{ backgroundColor: idx % 2 === 0 ? "#fff" : "#f5f8fc" }}>
                              <td style={{ padding: "8px 12px", fontSize: "12px", textAlign: "center", borderTop: "none", borderLeft: "none", borderRight: "none", borderBottom: "1px solid #dee2e6" }}>{idx + 1}</td>
                              <td style={{ padding: "8px 12px", fontSize: "12px", textAlign: "left", borderTop: "none", borderLeft: "none", borderRight: "none", borderBottom: "1px solid #dee2e6" }}>{item.oldSeverity || "—"}</td>
                              <td style={{ padding: "8px 12px", fontSize: "12px", textAlign: "left", borderTop: "none", borderLeft: "none", borderRight: "none", borderBottom: "1px solid #dee2e6" }}>{item.newSeverity || "—"}</td>
                              <td style={{ padding: "8px 12px", fontSize: "12px", textAlign: "left", borderTop: "none", borderLeft: "none", borderRight: "none", borderBottom: "1px solid #dee2e6" }}>{item.changedBy || "—"}</td>
                              <td style={{ padding: "8px 12px", fontSize: "12px", textAlign: "left", borderTop: "none", borderLeft: "none", borderRight: "none", borderBottom: "1px solid #dee2e6" }}>{item.remarks || "—"}</td>
                              <td style={{ padding: "8px 12px", fontSize: "12px", textAlign: "left", borderTop: "none", borderLeft: "none", borderRight: "none", borderBottom: "1px solid #dee2e6" }}>{item.changedOn || "—"}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              )}

             {/* Resources Section */}
<div className="row mt-3">
  <div className="col-sm-12">
    <div style={{
      background: 'linear-gradient(135deg, #f0f7ff 0%, #e8f4f8 100%)',
      border: '1px solid #c8dff0',
      borderRadius: '10px',
      overflow: 'hidden',
    }}>
      {/* Section Header - Clickable */}
      <div
        onClick={() => setIsResourcesExpanded(prev => !prev)}
        style={{
          padding: '12px 20px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          cursor: 'pointer',
          userSelect: 'none',
          borderBottom: isResourcesExpanded ? '1px solid #c8dff0' : 'none',
          background: isResourcesExpanded ? 'linear-gradient(135deg, #e3f0fb 0%, #d6eaf8 100%)' : 'transparent',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <span style={{
            width: '3px', height: '18px',
            background: '#1a6fa8',
            borderRadius: '2px',
            display: 'inline-block'
          }}></span>
          <span style={{
            fontSize: '13px', fontWeight: '700',
            color: '#1a5276', letterSpacing: '0.08em',
            textTransform: 'uppercase',
          }}>
            Resource Allocation & Deployment Details
          </span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          {fullResourcesData.length === 0 &&
            (formData?.status === "Started" || formData?.status === "In-Progress") && (
            <button
              type="button"
              onClick={(e) => {
                e.stopPropagation();
                handleOpenResourceEditModal();
              }}
              style={{
                display: 'flex', alignItems: 'center', gap: '6px',
                background: '#fff', border: '1px solid #1a6fa8',
                color: '#1a6fa8', borderRadius: '6px',
                padding: '4px 12px', fontSize: '12px', fontWeight: '600',
                cursor: 'pointer',
              }}
            >
              <FaPencilAlt size={11} /> Edit
            </button>
          )}
          {isResourcesExpanded ? <FaChevronUp size={16} color="#1a6fa8" /> : <FaChevronDown size={16} color="#1a6fa8" />}
        </div>
      </div>

      {/* Collapsible Content */}
      {isResourcesExpanded && (
        <div style={{ padding: '16px 20px' }}>
      {fullResourcesData.length > 0 ? (
        <div style={{ display: 'flex', gap: '24px', flexWrap: 'wrap' }}>

          {/* Automatic Resources — only shown when is_auto_triggered is true */}
          {formData?.is_auto_triggered && automaticResources.length > 0 && (
            <div style={{ flex: '1', minWidth: '260px' }}>
              {/* Auto Radio Header */}
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px' }}>
                <span
                  title="Automated resources cannot be deployed"
                  style={{ display: 'flex', alignItems: 'center', gap: '6px', cursor: 'not-allowed' }}
                >
                  <input
                    type="radio"
                    name="resourceType"
                    value="auto"
                    disabled
                    checked={true}
                    style={{ accentColor: '#27ae60', cursor: 'not-allowed', width: '14px', height: '14px' }}
                  />
                  <span style={{
                    display: 'flex', alignItems: 'center', gap: '6px',
                  }}>
                    <span style={{
                      fontSize: '11px', fontWeight: '600',
                      color: '#27ae60', textTransform: 'uppercase',
                      letterSpacing: '0.06em'
                    }}>Automatic</span>
                  </span>
                </span>
              </div>

              <div style={{
                background: 'white',
                borderRadius: '8px',
                border: '1px solid #d5ecd9',
                overflow: 'hidden',
                maxHeight: '220px',
                overflowY: 'auto'
              }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12px' }}>
                  <thead>
                    <tr style={{ background: '#d5ecd9', position: 'sticky', top: 0, zIndex: 1 }}>
                      <th style={{ padding: '7px 10px', textAlign: 'left', fontWeight: '600', color: '#ffffff', borderBottom: '1px solid #b2d8bb' }}>Resource Name</th>
                      <th style={{ padding: '7px 10px', textAlign: 'left', fontWeight: '600', color: '#ffffff', borderBottom: '1px solid #b2d8bb' }}>Facility</th>
                      <th style={{ padding: '7px 10px', textAlign: 'center', fontWeight: '600', color: '#ffffff', borderBottom: '1px solid #b2d8bb', whiteSpace: 'nowrap' }}>Available</th>
                      <th style={{ padding: '7px 10px', textAlign: 'center', fontWeight: '600', color: '#ffffff', borderBottom: '1px solid #b2d8bb', whiteSpace: 'nowrap' }}>Qty Deployed</th>
                    </tr>
                  </thead>
                  <tbody>
                    {automaticResources.map((resource, index) => (
                      <tr key={`auto-${index}`} style={{
                        background: index % 2 === 0 ? '#fafffe' : 'white',
                        borderBottom: '1px solid #edf7ee',
                      }}>
                        <td style={{ padding: '7px 10px', fontWeight: '500', color: '#2d6a4f', textAlign: 'left' }}>
                          {resource.name}
                        </td>
                        <td style={{ padding: '7px 10px', fontWeight: '400', color: '#2d6a4f', textAlign: 'left' }}>
                          {resource.facility_name ?? '-'}
                        </td>
                        <td style={{ padding: '7px 10px', textAlign: 'center', fontWeight: '700', color: '#27ae60', fontSize: '13px' }}>
                          {resource.available_quantity ?? '-'}
                        </td>
                        <td style={{ padding: '7px 10px', textAlign: 'center', fontWeight: '700', color: '#e67e22', fontSize: '13px' }}>
                          {resource.required_quantity ?? '-'}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {/* Divider */}
          {formData?.is_auto_triggered && automaticResources.length > 0 && manualResources.length > 0 && (
            <div style={{
              width: '1px',
              background: 'linear-gradient(to bottom, transparent, #c8dff0, transparent)',
              alignSelf: 'stretch'
            }}></div>
          )}

          {/* Manual Resources */}
                        {manualResources.length > 0 && (
                          <div style={{ flex: '1', minWidth: '260px' }}>
                            {/* Manual Header + Select All + Search - Single Row */}
                            <div style={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'space-between',
                              marginTop: '-4px',
                              marginBottom: '3px',
                              gap: '12px'
                            }}>
                              {/* Left: Manual label + Select All */}
                              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                <input
                                    type="checkbox"
                                    checked={areAllFilteredSelected}
                                    disabled={!canSelectResources}
                                    onChange={() => areAllFilteredSelected ? handleDeselectAllResources() : handleSelectAllResources()}
                                    style={{
                                      accentColor: '#2980b9', width: '13px', height: '13px',
                                      cursor: canSelectResources ? 'pointer' : 'not-allowed',
                                      opacity: canSelectResources ? 1 : 0.5,
                                    }}
                                  /> <span style={{
                                  fontSize: '11px', fontWeight: '600',
                                  color: '#2980b9', textTransform: 'uppercase',
                                  letterSpacing: '0.06em'
                                }}>Manual</span>
                                {selectedManualResources.length > 0 && (
                                  <span style={{
                                    fontSize: '10px',
                                    color: '#fff',
                                    backgroundColor: '#2980b9',
                                    padding: '1px 7px',
                                    borderRadius: '10px',
                                    fontWeight: '600'
                                  }}>
                                    {selectedManualResources.length} selected
                                  </span>
                                )}
                              </div>

                              {/* Right: Search Bar */}
                              <div style={{ position: 'relative', width: '180px' }}>
                                <input
                                  type="text"
                                  placeholder="Search resources..."
                                  value={resourceSearchTerm}
                                  onChange={(e) => setResourceSearchTerm(e.target.value)}
                                  style={{
                                    width: '100%',
                                    padding: '5px 28px 5px 10px',
                                    fontSize: '11px',
                                    border: '1px solid #d0e8f5',
                                    borderRadius: '6px',
                                    outline: 'none',
                                    color: '#1a4e7a',
                                    backgroundColor: '#fff',
                                  }}
                                />
                                {resourceSearchTerm && (
                                  <span
                                    onClick={() => setResourceSearchTerm("")}
                                    style={{
                                      position: 'absolute', right: '8px', top: '50%',
                                      transform: 'translateY(-50%)', cursor: 'pointer',
                                      fontSize: '14px', color: '#999', lineHeight: 1
                                    }}
                                  >×</span>
                                )}
                              </div>
                            </div>

                            {/* Resource Table */}
                            <div style={{
                              background: 'white',
                              borderRadius: '8px',
                              border: '1px solid #d0e8f5',
                              overflow: 'hidden',
                              maxHeight: '220px',
                              overflowY: 'auto'
                            }}>
                              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12px' }}>
                                <thead>
                                  <tr style={{ background: '#dbeeff', position: 'sticky', top: 0, zIndex: 1 }}>
                                    <th style={{ padding: '7px 10px', textAlign: 'center', fontWeight: '600', color: '#1a4e7a', borderBottom: '1px solid #c0d9f0', width: '32px' }}></th>
                                    <th style={{ padding: '7px 10px', textAlign: 'left', fontWeight: '600', color: '#ffffff', borderBottom: '1px solid #c0d9f0' }}>Resource Name</th>
                                    <th style={{ padding: '7px 10px', textAlign: 'left', fontWeight: '600', color: '#ffffff', borderBottom: '1px solid #c0d9f0' }}>Facility</th>
                                    <th style={{ padding: '7px 10px', textAlign: 'center', fontWeight: '600', color: '#ffffff', borderBottom: '1px solid #c0d9f0', whiteSpace: 'nowrap' }}>Available</th>
                                    <th style={{ padding: '7px 10px', textAlign: 'center', fontWeight: '600', color: '#ffffff', borderBottom: '1px solid #c0d9f0', whiteSpace: 'nowrap' }}>Qty To Deploy</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {filteredManualResources.length > 0 ? (
                                    filteredManualResources.map((resource, index) => {
                                      const isSelected = selectedManualResources.includes(resource.id);
                                      return (
                                        <tr
                                          key={`manual-${resource.id}`}
                                          onClick={canSelectResources ? () => handleResourceCheckbox(resource.id) : undefined}
                                          style={{
                                            background: isSelected ? '#d6f0dd' : (index % 2 === 0 ? '#fafdff' : 'white'),
                                            borderLeft: isSelected ? '3px solid #28a745' : '3px solid transparent',
                                            cursor: canSelectResources ? 'pointer' : 'default',
                                            transition: 'background 0.15s ease, border-left 0.15s ease',
                                            borderBottom: '1px solid #eaf3fb',
                                          }}
                                        >
                                          <td style={{ padding: '7px 10px', textAlign: 'center' }}>
                                            <input
                                              type="checkbox"
                                              checked={isSelected}
                                              disabled={!canSelectResources}
                                              onChange={() => handleResourceCheckbox(resource.id)}
                                              onClick={e => e.stopPropagation()}
                                              style={{
                                                accentColor: '#2980b9', width: '14px', height: '14px',
                                                cursor: canSelectResources ? 'pointer' : 'not-allowed',
                                                opacity: canSelectResources ? 1 : 0.5,
                                              }}
                                            />
                                          </td>
                                          <td style={{ padding: '7px 10px', fontWeight: '500', color: isSelected ? '#1a5e2a' : '#1a4e7a', textAlign: 'left' }}>
                                            {resource.name}
                                          </td>
                                          <td style={{ padding: '7px 10px', fontWeight: '400', color: isSelected ? '#1a5e2a' : '#1a4e7a', textAlign: 'left' }}>
                                            {resource.facility_name ?? '-'}
                                          </td>
                                          <td style={{ padding: '7px 10px', textAlign: 'center', fontWeight: '700', color: '#27ae60', fontSize: '13px' }}>
                                            {resource.available_quantity ?? '-'}
                                          </td>
                                          <td style={{ padding: '7px 10px', textAlign: 'center', fontWeight: '700', color: '#e67e22', fontSize: '13px' }}>
                                            {resource.required_quantity ?? '-'}
                                          </td>
                                        </tr>
                                      );
                                    })
                                  ) : (
                                    <tr>
                                      <td colSpan={5} style={{ padding: '12px 14px', fontSize: '12px', color: '#95a5a6', fontStyle: 'italic', textAlign: 'center' }}>
                                        No resources match your search
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        )}

        </div>
      ) : (
        <div style={{ color: '#95a5a6', fontSize: '13px', fontStyle: 'italic' }}>
          No resources assigned
        </div>
      )}
        </div>
      )}
    </div>
  </div>
</div>

              {/* Severity Change History */}
              <div className="mt-4">
                <button
                  className={`btn ${
                    formData?.status === "Closed"
                      ? "btn-closed-sop"
                      : "btn-close-sop"
                  }`}
                  style={{
                    backgroundColor:
                      formData?.status === "Closed" ? "#7cdb90" : "blue",
                    border: "none",
                    width: "121px"
                  }}
                  onClick={handleClickClose}
                  disabled={formData?.status !== "Completed"} // Button is enabled only when status is "Completed"
                >
                  {formData?.status === "Closed" ? "Closed" : "Close SOP"}
                </button>
                <button
                  className="btn btn-close-sops"
                  onClick={handleclickCancel}
                  disabled={formData?.status !== "Started"}
                  style={{height: "35px"}}
                >
                  Cancel SOP
                </button>
                <span
                  title={selectedManualResources.length === 0 ? "Select manual resources to enable deployment" : ""}
                  style={{ display: 'inline-block', marginLeft: '15px' }}
                >
    <button
  className="btn"
  onClick={handleDeployResources}
  disabled={selectedManualResources.length === 0}
  style={{
    backgroundColor: selectedManualResources.length > 0 ? "#28a745" : "#9e9e9e",
    border: "none",
    padding: "7px 10px",
    borderRadius: "0.25rem",
    color: "white",
    fontWeight: "200",
    fontSize: "12px",
    lineHeight: "1.5",
    textAlign: "center",
    whiteSpace: "nowrap",
    verticalAlign: "middle",
    cursor: selectedManualResources.length === 0 ? "not-allowed" : "pointer",
    height: "34px",
    marginBottom: "16px",
    marginTop: "16px",
    marginLeft: "0px",
    pointerEvents: selectedManualResources.length === 0 ? "none" : "auto",
    transition: "background-color 0.2s ease"
  }}
>
  Deploy Resources ({selectedManualResources.length})
</button>
  </span>
  
              </div>
              {showPop && (
                <TaskModalWithCommentSopCancel
                  titleValue={t("Cancel SOP Instance")}
                  show={showPop}
                  setShowPop={setShowPop}
                  taskData={formData}
                />
              )}
              {showConfirmPopup && (
                <ConfirmpopupSop
                  titleValue={t("Close SOP Instance")}
                  show={showConfirmPopup}
                  setshowConfirmPopup={setshowConfirmPopup}
                  taskData={formData}
                />
              )}
            </div>
          </div>
        </div>
      </div>

      {/* No Resources Found Popup */}
      {showNoResourcesModal && (
        <div
          style={{
            position: "fixed", inset: 0, zIndex: 9999,
            backgroundColor: "rgba(0,0,0,0.45)",
            display: "flex", alignItems: "center", justifyContent: "center",
          }}
        >
          <div style={{
            background: "#fff",
            borderRadius: "12px",
            width: editResources.length > 0 ? "560px" : "420px",
            maxWidth: "95vw",
            boxShadow: "0 8px 32px rgba(0,0,0,0.18)",
            overflow: "hidden",
          }}>
            {/* Header */}
            <div style={{ background: "#1C4E72", padding: "14px 20px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
              <span style={{ color: "#fff", fontWeight: "700", fontSize: "14px" }}>
                Resource Allocation & Deployment
              </span>
              <span
                onClick={() => setShowNoResourcesModal(false)}
                style={{ cursor: "pointer", color: "#fff", fontSize: "18px", lineHeight: 1 }}
              >
                ×
              </span>
            </div>

            {isLoadingEditResources ? (
              <div style={{ padding: "36px 24px", textAlign: "center", fontSize: "13px", color: "#8a97a3" }}>
                Loading resources...
              </div>
            ) : editResources.length > 0 ? (
              <>
                {/* Body — resource list */}
                <div style={{ padding: "16px 20px" }}>
                  {editResources.length > 1 && (
                    <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "8px" }}>
                      <label style={{ display: "flex", alignItems: "center", gap: "6px", fontSize: "11px", color: "#1a5276", cursor: "pointer" }}>
                        <input
                          type="checkbox"
                          checked={editResources.every((r, i) => checkedEditResources[r.resourceId ?? i])}
                          onChange={(e) => handleSelectAllEditResources(e.target.checked)}
                        />
                        Select All
                      </label>
                    </div>
                  )}
                  <div style={{ maxHeight: "300px", overflowY: "auto", border: "1px solid #d5e6f2", borderRadius: "6px" }}>
                    <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "12px" }}>
                      <thead>
                        <tr>
                          <th className="resource-edit-modal-th" style={{ padding: "7px 10px", textAlign: "left", fontWeight: "600", width: "32px" }}></th>
                          <th className="resource-edit-modal-th" style={{ padding: "7px 10px", textAlign: "left", fontWeight: "600" }}>Resource Name</th>
                          <th className="resource-edit-modal-th" style={{ padding: "7px 10px", textAlign: "left", fontWeight: "600" }}>Facility</th>
                        </tr>
                      </thead>
                      <tbody>
                        {editResources.map((resource, index) => {
                          const key = resource.resourceId ?? index;
                          return (
                            <tr key={key} style={{
                              background: index % 2 === 0 ? "#fafcfe" : "#fff",
                              borderBottom: "1px solid #eef4f9",
                            }}>
                              <td style={{ padding: "7px 10px" }}>
                                <input
                                  type="checkbox"
                                  checked={!!checkedEditResources[key]}
                                  onChange={() => handleEditResourceCheckbox(key)}
                                />
                              </td>
                              <td style={{ padding: "7px 10px", color: "#2d3b47" }}>{resource.resource_name}</td>
                              <td style={{ padding: "7px 10px", color: "#2d3b47" }}>{resource.facility_name ?? "-"}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>

                {/* Footer */}
                <div style={{ padding: "0 20px 16px", display: "flex", justifyContent: "flex-end", gap: "10px" }}>
                  <button
                    onClick={() => setShowNoResourcesModal(false)}
                    style={{
                      padding: "7px 20px", borderRadius: "6px", border: "1px solid #adb5bd",
                      background: "#fff", color: "#333", fontSize: "12px", cursor: "pointer", fontWeight: "500",
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    onClick={handleUpdateResources}
                    disabled={isUpdatingResources || !editResources.some((r, i) => checkedEditResources[r.resourceId ?? i])}
                    style={{
                      padding: "7px 20px", borderRadius: "6px", border: "none",
                      background: (isUpdatingResources || !editResources.some((r, i) => checkedEditResources[r.resourceId ?? i])) ? "#94a9bb" : "#1C4E72",
                      color: "#fff", fontSize: "12px",
                      cursor: (isUpdatingResources || !editResources.some((r, i) => checkedEditResources[r.resourceId ?? i])) ? "not-allowed" : "pointer",
                      fontWeight: "600",
                    }}
                  >
                    {isUpdatingResources ? "Updating..." : "Update"}
                  </button>
                </div>
              </>
            ) : (
              <>
                {/* Body — empty state */}
                <div style={{ padding: "36px 24px", textAlign: "center" }}>
                  <div style={{
                    width: "48px", height: "48px", borderRadius: "10px",
                    background: "#fdeee0", display: "flex", alignItems: "center",
                    justifyContent: "center", margin: "0 auto 16px",
                  }}>
                    <FaClipboardList size={20} color="#e67e22" />
                  </div>
                  <div style={{ fontSize: "15px", fontWeight: "700", color: "#1a1a1a", marginBottom: "6px" }}>
                    No Resources Found
                  </div>
                  <div style={{ fontSize: "13px", color: "#8a97a3" }}>
                    Please add resources for this SOP and then update.
                  </div>
                </div>

                {/* Footer */}
                <div style={{ padding: "0 20px 16px", display: "flex", justifyContent: "flex-end" }}>
                  <button
                    onClick={() => setShowNoResourcesModal(false)}
                    style={{
                      padding: "7px 20px", borderRadius: "6px", border: "1px solid #adb5bd",
                      background: "#fff", color: "#333", fontSize: "12px", cursor: "pointer", fontWeight: "500",
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      )}

      {/* Severity Change Popup */}
      {showSeverityPopup && (
        <div
          style={{
            position: "fixed", inset: 0, zIndex: 9999,
            backgroundColor: "rgba(0,0,0,0.45)",
            display: "flex", alignItems: "center", justifyContent: "center",
          }}
        >
          <div style={{
            background: "#fff",
            borderRadius: "12px",
            width: "520px",
            maxWidth: "95vw",
            boxShadow: "0 8px 32px rgba(0,0,0,0.18)",
            overflow: "hidden",
          }}>
            {/* Header */}
            <div style={{ background: "#1C4E72", padding: "14px 20px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
              <span style={{ color: "#fff", fontWeight: "700", fontSize: "14px" }}>
                Change Severity — {pendingSeverity}
              </span>
              <span
                onClick={handleSeverityPopupCancel}
                style={{ color: "#fff", cursor: "pointer", fontSize: "18px", lineHeight: 1 }}
              >&#x2715;</span>
            </div>

            {/* Resource Table */}
            <div style={{ padding: "16px 20px 10px" }}>
              <div style={{ marginBottom: "8px", fontSize: "12px", fontWeight: "600", color: "#1C4E72" }}>
                Resources for this Severity Level
              </div>
              <div style={{ border: "1px solid #000", borderRadius: "8px", overflow: "hidden", maxHeight: "220px", overflowY: "auto" }}>
                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                  <thead>
                    <tr>
                      <th style={{ backgroundColor: "#1C4E72", color: "#fff", padding: "8px 12px", textAlign: "left", fontSize: "11px", fontWeight: "600", border: "none" }}>Resource Name</th>
                      <th style={{ backgroundColor: "#1C4E72", color: "#fff", padding: "8px 12px", textAlign: "center", fontSize: "11px", fontWeight: "600", border: "none", width: "120px" }}>Qty To Deploy</th>
                    </tr>
                  </thead>
                  <tbody>
                    {severityResources.length > 0 ? severityResources.map((r, idx) => (
                      <tr key={idx}>
                        <td style={{ padding: "6px 12px", fontSize: "11px", color: "#1a2e35", textAlign: "left", borderTop: "none", borderLeft: "none", borderRight: "none", borderBottom: "1px solid #dee2e6" }}>
                          {r.resourceName || "NA"}
                        </td>
                        <td style={{ padding: "6px 12px", fontSize: "11px", color: "#1a2e35", textAlign: "center", borderTop: "none", borderLeft: "none", borderRight: "none", borderBottom: "1px solid #dee2e6" }}>
                          {r.requiredQuantity ?? "0"}
                        </td>
                      </tr>
                    )) : (
                      <tr>
                        <td colSpan={2} style={{ padding: "16px", textAlign: "center", fontSize: "11px", color: "#888", border: "none" }}>
                          No resources found for this severity level
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>

            {/* Reason Box */}
            <div style={{ padding: "4px 20px 16px" }}>
              <label style={{ fontSize: "12px", fontWeight: "600", color: "#1C4E72", display: "block", marginBottom: "6px" }}>
                Reason to change severity <span style={{ color: "#e74c3c" }}>*</span>
              </label>
              <textarea
                rows={3}
                maxLength={250}
                value={severityChangeReason}
                onChange={e => setSeverityChangeReason(e.target.value)}
                placeholder="Enter reason for changing severity level..."
                style={{
                  width: "100%",
                  border: "1px solid #001b30",
                  borderRadius: "4px",
                  padding: "8px 10px",
                  fontSize: "12px",
                  resize: "vertical",
                  outline: "none",
                  fontFamily: "inherit",
                }}
              />
              <div style={{ textAlign: "right", fontSize: "11px", color: "#9ca3af", marginTop: "4px" }}>
                {severityChangeReason.length}/250
              </div>
            </div>

            {/* Buttons */}
            <div style={{ padding: "0 20px 16px", display: "flex", justifyContent: "flex-end", gap: "10px" }}>
              <button
                onClick={handleSeverityPopupCancel}
                style={{
                  padding: "7px 20px", borderRadius: "6px", border: "1px solid #adb5bd",
                  background: "#fff", color: "#333", fontSize: "12px", cursor: "pointer", fontWeight: "500",
                }}
              >
                Cancel
              </button>
              <button
                onClick={handleSeverityPopupSubmit}
                disabled={!severityChangeReason.trim()}
                style={{
                  padding: "7px 20px", borderRadius: "6px", border: "none",
                  background: severityChangeReason.trim() ? "#1C4E72" : "#adb5bd",
                  color: "#fff", fontSize: "12px", cursor: severityChangeReason.trim() ? "pointer" : "not-allowed",
                  fontWeight: "600",
                }}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
export default SopsInstanceForm;